module.exports = __webpack_public_path__ + "static/media/vegitables_52.5fe445f5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_52.csv
// module id = 638
// module chunks = 0